import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Version } from '../../utils/types/ProjectType';
import { formatVersions } from '../../utils/general';

interface VersionDropdownProps {
  currentProjectId: string;
  onChange: (projectId: string) => void;
  versions: Version[];
}

function VersionDropdown(props: VersionDropdownProps) {
  const { versions, currentProjectId, onChange } = props;

  return (
    <Box mb={2}>
      <FormControl fullWidth size="small">
        <InputLabel id="version-select-label">Version</InputLabel>
        <Select
          label="Version"
          labelId="version-select-label"
          onChange={(e) => onChange(e.target.value as string)}
          value={
            versions.find((v) => v.projectId === currentProjectId)?.projectId ||
            ''
          }
        >
          {versions.map((version) => (
            <MenuItem key={version.projectId} value={version.projectId}>
              {`${formatVersions(version.projectVersion)}`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default VersionDropdown;
